import React from "react";
import { Box, Container, Typography, Grid, Button, Paper, Chip } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import VerifiedIcon from "@mui/icons-material/Verified";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AgricultureIcon from "@mui/icons-material/Agriculture";

const CentraleAchatTeaser = () => {
  return (
    <Box
      sx={{
        bgcolor: "#01321d",
        backgroundImage: "radial-gradient(circle at 10% 20%, rgba(16, 185, 129, 0.18) 0%, transparent 40%), radial-gradient(circle at 90% 80%, rgba(245, 158, 11, 0.15) 0%, transparent 45%)",
        color: "#ffffff",
        py: { xs: 5, md: 7 },
        position: "relative",
        borderTop: "1px solid rgba(255, 255, 255, 0.08)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.08)"
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Texte & Titre */}
          <Grid item xs={12} md={7}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5, flexWrap: "wrap" }}>
              <Chip
                icon={<StorefrontIcon sx={{ fontSize: "15px !important", color: "#f59e0b !important" }} />}
                label="Centrale d'Achat & Marketplace Officielle"
                size="small"
                sx={{
                  bgcolor: "rgba(245, 158, 11, 0.15)",
                  color: "#fbbf24",
                  fontWeight: 700,
                  fontSize: "0.75rem",
                  border: "1px solid rgba(245, 158, 11, 0.3)"
                }}
              />
              <Chip
                label="Phase Pilote : Grand Libreville • Extension Provinces en Phase 2"
                size="small"
                sx={{
                  bgcolor: "rgba(255, 255, 255, 0.12)",
                  color: "#ffffff",
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  border: "1px solid rgba(255, 255, 255, 0.2)"
                }}
              />
            </Box>

            <Typography
              variant="h3"
              component="h2"
              sx={{
                fontWeight: 900,
                fontSize: { xs: "1.85rem", sm: "2.4rem", md: "2.8rem" },
                lineHeight: 1.2,
                mb: 2,
                letterSpacing: "-0.5px"
              }}
            >
              Vente Directe & Approvisionnement Agricole Tracé
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "rgba(255, 255, 255, 0.88)",
                fontSize: { xs: "0.95rem", sm: "1.05rem" },
                lineHeight: 1.6,
                mb: 2.5
              }}
            >
              Particuliers, restaurateurs, supermarchés et grossistes : la Centrale d'Achat Agri Vision Gabon démarre son déploiement en priorité pour approvisionner le <strong>Grand Libreville (Akanda, Owendo et Libreville)</strong>. Accédez à nos récoltes certifiées bord champ (manioc, banane plantain, ananas Victoria, maraîchage frais et fruits locaux) avec livraison garantie sous 24h à 48h. Le réseau s'étendra ensuite progressivement aux autres provinces du Gabon en <strong>Phase 2</strong>.
            </Typography>

            {/* Note d'information Phase Pilote */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.2,
                bgcolor: "rgba(16, 185, 129, 0.12)",
                border: "1px solid rgba(16, 185, 129, 0.3)",
                borderRadius: "12px",
                p: 1.5,
                mb: 3
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: "#10b981",
                  boxShadow: "0 0 10px #10b981",
                  flexShrink: 0
                }}
              />
              <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "0.85rem", lineHeight: 1.4 }}>
                <strong>Phase 1 en cours :</strong> Livraison exclusive dans le Grand Libreville (Akanda, Owendo, Libreville) • <strong>Phase 2 :</strong> Déploiement progressif dans l'ensemble des provinces du Gabon.
              </Typography>
            </Box>

            {/* Piliers clés */}
            <Grid container spacing={2} sx={{ mb: 3.5 }}>
              <Grid item xs={6} sm={3}>
                <Box sx={{ borderLeft: "3px solid #10b981", pl: 1.5 }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, color: "#ffffff", fontSize: "1.1rem" }}>
                    20+
                  </Typography>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.72rem" }}>
                    Lots certifiés
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Box sx={{ borderLeft: "3px solid #f59e0b", pl: 1.5 }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, color: "#ffffff", fontSize: "1.05rem" }}>
                    Phase 1
                  </Typography>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.72rem" }}>
                    Grand Libreville
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Box sx={{ borderLeft: "3px solid #3b82f6", pl: 1.5 }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, color: "#ffffff", fontSize: "1.05rem" }}>
                    Phase 2
                  </Typography>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.72rem" }}>
                    Provinces à venir
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Box sx={{ borderLeft: "3px solid #ec4899", pl: 1.5 }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, color: "#ffffff", fontSize: "1.1rem" }}>
                    24h - 48h
                  </Typography>
                  <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.72rem" }}>
                    Livraison garantie
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {/* Boutons d'action */}
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Button
                disabled
                variant="contained"
                size="large"
                startIcon={<StorefrontIcon sx={{ color: "rgba(255, 255, 255, 0.5) !important" }} />}
                sx={{
                  bgcolor: "rgba(255, 255, 255, 0.14) !important",
                  color: "rgba(255, 255, 255, 0.6) !important",
                  border: "1px solid rgba(255, 255, 255, 0.22)",
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  px: 3,
                  py: 1.3,
                  borderRadius: "30px",
                  textTransform: "none",
                  boxShadow: "none !important",
                  cursor: "not-allowed !important",
                  pointerEvents: "auto !important",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1.2
                }}
              >
                <span>Accéder à la Centrale d'Achat</span>
                <Box
                  component="span"
                  sx={{
                    bgcolor: "rgba(255, 255, 255, 0.22)",
                    color: "#ffffff",
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    px: 1,
                    py: 0.35,
                    borderRadius: "12px",
                    textTransform: "none",
                    letterSpacing: "0.3px",
                    lineHeight: 1
                  }}
                >
                  Bientôt disponible
                </Box>
              </Button>

              <Button
                href="https://wa.me/24104126488?text=Bonjour%20Agri%20Vision%20Gabon%2C%20je%20souhaite%20m%27approvisionner%20aupr%C3%A8s%20de%20la%20Centrale%20d%27Achat."
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                size="large"
                startIcon={<WhatsAppIcon sx={{ color: "#25D366" }} />}
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.3)",
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "0.92rem",
                  px: 2.8,
                  py: 1.3,
                  borderRadius: "30px",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#25D366",
                    bgcolor: "rgba(37, 211, 102, 0.1)"
                  }
                }}
              >
                Service Commandes WhatsApp
              </Button>
            </Box>
          </Grid>

          {/* Cartes d'avantages & aperçu visuel */}
          <Grid item xs={12} md={5}>
            <Paper
              elevation={4}
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.05)",
                backdropFilter: "blur(12px)",
                border: "1px solid rgba(255, 255, 255, 0.12)",
                borderRadius: "20px",
                p: { xs: 2.5, sm: 3.5 }
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 800, mb: 2, color: "#ffffff" }}>
                Comment s'approvisionner ?
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "12px",
                      bgcolor: "rgba(16, 185, 129, 0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}
                  >
                    <AgricultureIcon sx={{ color: "#34d399", fontSize: 22 }} />
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#ffffff" }}>
                      1. Phase Pilote : Grand Libreville
                    </Typography>
                    <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.72)", fontSize: "0.82rem" }}>
                      Approvisionnement prioritaire sur Akanda, Owendo et Libreville, avant extension progressive aux autres provinces en Phase 2.
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "12px",
                      bgcolor: "rgba(245, 158, 11, 0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}
                  >
                    <VerifiedIcon sx={{ color: "#fbbf24", fontSize: 22 }} />
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#ffffff" }}>
                      2. Tarifs transparents & volume garanti
                    </Typography>
                    <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.72)", fontSize: "0.82rem" }}>
                      Prix au kilo et à la tonne affichés en toute transparence direct bord champ, sans intermédiaires spéculatifs.
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "12px",
                      bgcolor: "rgba(59, 130, 246, 0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}
                  >
                    <LocalShippingIcon sx={{ color: "#60a5fa", fontSize: 22 }} />
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#ffffff" }}>
                      3. Livraison sous 24h - 48h
                    </Typography>
                    <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.72)", fontSize: "0.82rem" }}>
                      Validation 1-clic via WhatsApp ou formulaire B2B avec livraison rapide et soignée dans le Grand Libreville.
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid rgba(255, 255, 255, 0.1)" }}>
                <Button
                  disabled
                  fullWidth
                  variant="contained"
                  sx={{
                    bgcolor: "rgba(255, 255, 255, 0.08) !important",
                    color: "rgba(255, 255, 255, 0.45) !important",
                    border: "1px solid rgba(255, 255, 255, 0.12)",
                    fontWeight: 600,
                    textTransform: "none",
                    borderRadius: "12px",
                    py: 1,
                    px: 2,
                    cursor: "not-allowed !important",
                    pointerEvents: "auto !important",
                    boxShadow: "none !important",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <span>Lots Centrale d'Achat</span>
                  <Box
                    component="span"
                    sx={{
                      bgcolor: "rgba(255, 255, 255, 0.16)",
                      color: "rgba(255, 255, 255, 0.8)",
                      fontSize: "0.68rem",
                      fontWeight: 700,
                      px: 1,
                      py: 0.25,
                      borderRadius: "8px",
                      textTransform: "none"
                    }}
                  >
                    Bientôt disponible
                  </Box>
                </Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CentraleAchatTeaser;
